import List from "./List/List";
import hasPermission from "/src/utils/hasPermission";
import './Home.css';

function Home({data}) {

    const { datasets, bots, username } = data;

    const sortList = (data)=>{
        return  data.sort((a, b) => { return new Date(b.updated_at) - new Date(a.updated_at)})
    }

    let botsSorted = sortList(bots);
    let datasetsSorted = sortList(datasets);
    return (
        <>
            <div className="feature-bar">
                <div className="welcome-message">
                    <div className="row">Hey {username} 👋</div>
                </div>
            </div>
            <div className="list-container">
                <div className="row">
                    {hasPermission('view_bots') ? <List title="Bots" data={botsSorted} type='bots' {...hasPermission('create_bot') ? {url : '/bot/create'} : null }/> : null }
                </div>
                <div className="row">
                    {hasPermission('view_datasets') ?  <List title="Datasets" data={datasetsSorted} type='datasets' {...hasPermission('create_dataset') ? {url : '/dataset/create'} : null }/> : null }
                </div>
            </div>
        </>
    )
}

export default Home;